import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BokkzAlgDataService,
  BokkzDivDataService,
  Dividendbelasting,
  DividendTaxEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-overzichtdividend',
  standalone: true,
  imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule],
  templateUrl: './overzicht.component.html',
  styleUrl: './overzicht.component.scss',
})
export class OverzichtComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private divTaxEntitySubscription: Subscription | undefined;
  public divTaxEntity = {} as DividendTaxEntity;
  public aangifte = {} as Dividendbelasting;
  public dividendFg = {} as FormGroup;
  public aangifteFg = {} as FormGroup;
  public opgaafFg = {} as FormGroup;
  public dividendSpecFg = {} as FormGroup;
  public focusedElementId: string | null = null;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzDivDataService,
    private fb: FormBuilder) {
    this.dividendFg = this.fb.group({
      bedragDividenduitkering: null as unknown as number,
      datumBeschikbaarstelling: null as unknown as Date,
    })
    this.aangifteFg = this.fb.group({
      aangifteNummer: null as unknown as string,
      verschuldigdeBelasting: null as unknown as number,
    })
    this.opgaafFg = this.fb.group({
      bedragDividenduitkering: null as unknown as number,
    })
    this.dividendSpecFg = this.fb.group({
      bedragDividenduitkering: null as unknown as number,
      bedragOnbelastVerbodExtraterritorialeHeffing: null as unknown as number,
      inhoudingsVrijstelling: this.fb.group({
        bedragInhoudingsvrijstelling: null as unknown as number,
        indicatieVerklaringArt1ab: null as unknown as boolean,
        indicatieVerklaringArt1ac: null as unknown as boolean,
        indicatieInkoopArtikel4c: null as unknown as boolean,
        omschrijvingAandelenInkoop: null as unknown as string,
        opAandelenGestortKapitaal: null as unknown as number,
        bedragInkoopEigenAandelen: null as unknown as number,
      }),
      belastVerdragsTarief: this.fb.group({
        bedragMetVerdragstoepassing: null as unknown as number,
        landCode: null as unknown as string,
        verdragsPercentage: null as unknown as number,
        indicatieVergunningVerdragstoepassing: null as unknown as boolean,
        indicatieIB92Universeel: null as unknown as boolean,
        indicatieIB96Usa: null as unknown as boolean,
        indicatieForm6166: null as unknown as boolean,
        belastingPerDividend: null as unknown as number,
      }),
      belastNormaalTarief: this.fb.group({
        bedragBelastNormaalTarief: null as unknown as number,
      }),
      afdrachtsVermindering: this.fb.group({
        bedragVerminderingArtikel11: null as unknown as number,
        bedragIngehoudenBelastingArtikel11a: null as unknown as number,
        bedragIngehoudenBuitenlandseBronbelasting: null as unknown as number,
        bedragIngehoudenBelastingArtikel12: null as unknown as number,
        bedragVerminderingArtikel12: null as unknown as number,
      }),
    })
  }

  ngOnInit(): void {
    this.divTaxEntitySubscription = this.dataService.dividendTaxEntity.subscribe((dividendTaxEntity)=> {
      this.divTaxEntity = dividendTaxEntity;
      const aangifte = dividendTaxEntity.aangifte
      if (aangifte) {
        this.aangifte = aangifte;
        this.dividendFg.patchValue(aangifte, {emitEvent: false})
        if (aangifte.aangifteDb) {
          this.aangifteFg.patchValue(aangifte.aangifteDb, {emitEvent: false})
        }
        if (aangifte.opgaafDb) {
          this.opgaafFg.patchValue(aangifte.opgaafDb, {emitEvent: false})
        }
        if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)) {
          this.dividendSpecFg.patchValue(this.aangifte.aangifteDb?.dividendSpecificaties[0], {emitEvent: false})
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.divTaxEntitySubscription) {
      this.divTaxEntitySubscription.unsubscribe()
    }
  }
}
